/**
 * Studio → Skills (index) — list view at exact `/studio/skills/`.
 *
 * Thin wrapper that mounts the shared `<SkillEditor scope="tenant" />`.
 * All skills authoring logic lives in
 * `@/components/skill-editor-shared/SkillEditor.tsx` — this file's job
 * is just the TanStack file-route binding so the framework picks up
 * the route at /studio/skills/.
 *
 * The detail page at /studio/skills/:skillId is the canonical full edit
 * surface; the Sheet in `<SkillEditor>` remains for quick create + quick
 * edit. The pencil action on each row opens the Sheet; users can open
 * the full detail page via the row's link affordance (the slug cell).
 */
import { createFileRoute } from '@tanstack/react-router';
import { SkillEditor } from '@/components/skill-editor-shared/SkillEditor';

export const Route = createFileRoute('/studio/skills/')({
  component: StudioSkillsIndexPage,
});

function StudioSkillsIndexPage() {
  return <SkillEditor scope="tenant" />;
}
